import React from 'react';
import { HashLink as NavLink } from 'react-router-hash-link';
import Typed from 'react-typed';
import { headerData } from '../../../data/headerData';
import './landing.css';
import {FaGithub, FaLinkedin} from 'react-icons/fa';
import { contactsData } from '../../../data/contactsData';
import { useTranslation } from '../../../TranslationContext';

function LandingUI({ theme, drawerOpen, classes }) {
    const { translate } = useTranslation();

    return (
        <div className='landing' style={{ backgroundColor: theme.quaternary }}>
            <div className='landing--container'>
                <div
                    className='landing--container-left'
                    style={{ backgroundColor: theme.quaternary }}
                >
                    <div className='lcl--content'>
                    {contactsData.github && (
                            <a
                                href={contactsData.github}
                                target='_blank'
                                rel='noreferrer'
                            >
                                <FaGithub
                                    className='landing--social'
                                    style={{ color: theme.tertiary }}
                                    aria-label='GitHub'
                                />
                            </a>
                        )}
                        {contactsData.linkedIn && (
                            <a
                                href={contactsData.linkedIn}
                                target='_blank'
                                rel='noreferrer'
                            >
                                <FaLinkedin
                                    className='landing--social linkedin-icon'
                                    style={{ color: theme.primary }}
                                    aria-label='LinkedIn'
                                />
                            </a>
                        )}
                    </div>
                </div>
                <img
                    src={headerData.image}
                    alt=''
                    className='landing--img'
                    style={{
                        opacity: `${drawerOpen ? '0' : '1'}`,
                        borderColor: theme.primary,
                    }}
                />
                <div
                    className='landing--container-right'
                    style={{ backgroundColor: theme.secondary }}
                >
                    <div
                        className='lcr--content'
                        style={{ color: theme.tertiary }}
                    >
                        <h1>{translate('title', 'landing')}</h1>
                        <Typed
                            strings={[
                                translate('typed1', 'landing'),
                                translate('typed2', 'landing'),
                                translate('typed3', 'landing'),
                                translate('typed4', 'landing'),
                            ]}
                            typeSpeed={50}
                            backSpeed={50}
                            className="typed-header"
                            style={{ color: theme.primary, fontSize: '25px' }}
                            loop
                        />
                        <p>{translate('description', 'landing')}</p>
                        
                            <NavLink
                                to='/#contacts'
                                smooth={true}
                                spy='true'
                                duration={2000}
                            >
                                <button className={`${classes.contactBtn} hide-before-900`}>
                                    Contact
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
    
    );
}

export default LandingUI;
